import * as React from "react";
import { useForm } from "react-hook-form";
import Modal from "../components/common/Modal";
import Button from "../components/common/PressableButton";
import Text from "../components/common/Text";

import useJoinClazz from "../hooks/clazzes/useJoinClazz";
import { TextInput } from "../styled-component";

function JoinClass() {
  const [isVisible, setIsVisible] = React.useState(false);
  const { watch, setValue, reset } = useForm({ defaultValues: { code: "" } });
  const { mutate: joinClazz, isLoading } = useJoinClazz(() => {
    setIsVisible(false);
    reset();
  });
  const code = watch("code");

  return (
    <>
      <Button
        title="Join Class"
        onPress={() => setIsVisible(true)}
        mode="contained"
      />

      <Modal
        title="Join a Class"
        onDismiss={() => setIsVisible(false)}
        isVisible={isVisible}
        primaryAction={
          <Button
            title="Join Class"
            onPress={() => joinClazz({ code })}
            disabled={isLoading}
            mode="contained"
          />
        }
        secondaryAction={
          <Modal.DismissButton
            onPress={() => setIsVisible(false)}
            disabled={isLoading}
          />
        }
        content={
          <Modal.Content>
            <Text.Label>Code</Text.Label>
            <TextInput
              editable={!isLoading}
              onChangeText={(nextCode) => setValue("code", nextCode)}
            />
          </Modal.Content>
        }
      />
    </>
  );
}

export default JoinClass;
